module.exports = __webpack_public_path__ + "img/asiatic-lilly.a1148bea.jpg";